import { render, staticRenderFns } from "./SearchPractices.vue?vue&type=template&id=b100ee42&scoped=true&"
import script from "./SearchPractices.vue?vue&type=script&lang=ts&"
export * from "./SearchPractices.vue?vue&type=script&lang=ts&"
import style0 from "./SearchPractices.vue?vue&type=style&index=0&id=b100ee42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b100ee42",
  null
  
)

export default component.exports